"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = exports.getLanguage = exports.Strings = void 0;
/*
 * read strings.auto.json,  go translation
 */
const i18n_1 = require("@apitable/i18n");
__exportStar(require("../../config/stringkeys.interface"), exports);
// String.key will return key, for compatibility
exports.Strings = new Proxy({}, {
    get: function (_target, key) {
        return key;
    },
});
const _global = global || window;
function getLanguage() {
    var _a, _b;
    let clientLang = null;
    if (_global.document) {
        // @ts-ignore
        clientLang = localStorage.getItem('client-lang');
    }
    if (!clientLang)
        clientLang = 'zh-CN';
    const language = typeof _global == 'object' && _global.__initialization_data__ && _global.__initialization_data__.locale;
    const defaultLang = (typeof _global == 'object' && ((_b = (_a = _global.__initialization_data__) === null || _a === void 0 ? void 0 : _a.envVars) === null || _b === void 0 ? void 0 : _b.SYSTEM_CONFIGURATION_DEFAULT_LANGUAGE)) || 'zh-CN';
    return clientLang || language || defaultLang;
}
exports.getLanguage = getLanguage;
const loadLanguage = (lang) => {
    console.log('start load language', lang);
    let data = {};
    if (typeof window !== 'undefined') {
        // @ts-ignore
        const xhr = new XMLHttpRequest();
        if (lang) {
            xhr.open('GET', `/file/langs/strings.${lang}.json`, false);
        }
        else {
            xhr.open('GET', '/file/langs/strings.json', false);
        }
        xhr.send();
        if (xhr.readyState === 4 && xhr.status === 200) {
            const languageData = JSON.parse(xhr.responseText);
            if (lang) {
                data[lang] = languageData;
            }
            else {
                data = languageData;
            }
        }
        else {
            console.error('load language from remote error', xhr.statusText);
        }
    }
    else {
        try {
            const fs = require('fs');
            const jsonData = fs.readFileSync(`${__dirname}/../../../../i18n-lang/src/config/strings.json`);
            data = JSON.parse(jsonData);
        }
        catch (error) {
            console.error('load strings.json error', error);
        }
    }
    return data;
};
const rewriteI18nForEdition = () => {
    var _a;
    for (const k in _global.apitable_i18n) {
        if ((_a = _global.apitable_i18n_edition) === null || _a === void 0 ? void 0 : _a[k]) {
            _global.apitable_i18n[k] = Object.assign(Object.assign({}, _global.apitable_i18n[k]), _global.apitable_i18n_edition[k]);
        }
    }
};
const currentLang = getLanguage();
_global.currentLang = currentLang;
_global.apitable_i18n = loadLanguage(currentLang);
require('@apitable/i18n-lang');
rewriteI18nForEdition();
const i18n = i18n_1.I18N.createByLanguagePacks(_global.apitable_i18n, currentLang);
function t(stringKey, options = null, isPlural = false) {
    return i18n.getText(stringKey, options, isPlural);
}
exports.t = t;
//# sourceMappingURL=index.js.map